import styled from "styled-components";

export const FilterBarWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
`;

/** 允许筛选控件在空间不足时收缩 */
export const FilterControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
`;

/** 固定操作按钮宽度，筛选控件空间不足时由控件区收缩 */
export const FilterActions = styled.div`
  display: flex;
  align-items: center;
  flex: none;
  gap: 10px;
`;
